export const getProductCarouselState = state => state.productCarousel.productCarouselData;
